import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './RescheduleSuccessDialog.css';
import SuccessIcon from '../../../assets/Model/success-icon.svg';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '8px',
  width: '400px',
  padding: '24px',
  textAlign: 'center',
};

const RescheduleSuccessDialog = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box className="flex justify-end">
          <CloseIcon onClick={onClose} sx={{ cursor: 'pointer', color: '#666666' }} />
        </Box>
        <Box className="flex flex-col items-center gap-4 mt-2">
          <img
            src={SuccessIcon}
            alt="Success"
            style={{ width: 200, height: 91, aspectRatio: 200 / 91 }}
          />
          <Typography className="success-title">Request sent successful!</Typography>
          <Typography className="success-message">
            We are processing your rescheduled request. You will receive updates on notifications.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default RescheduleSuccessDialog;
